/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Load_TitleInputs */

const en_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load Subtitle Export Preset`)
};

const fr_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger le préréglage d'exportation des sous-titres`)
};

const de_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel-Exportvorgabe laden`)
};

const it_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica preset di esportazione sottotitoli`)
};

const ru_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить предустановку экспорта субтитров`)
};

const es_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar ajuste preestablecido de exportación de subtítulos`)
};

const zh_cn2_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载字幕导出预设`)
};

const ja_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕エクスポートプリセットを読み込む`)
};

const hi_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबटाइटल एक्सपोर्ट प्रीसेट लोड करें`)
};

const pt_pt2_subtitle_export_preset_load_title = /** @type {(inputs: Subtitle_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar predefinição de exportação de legendas`)
};

/**
* | output |
* | --- |
* | "Load Subtitle Export Preset" |
*
* @param {Subtitle_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_load_title = /** @type {((inputs?: Subtitle_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_load_title(inputs)
	if (locale === "de") return de_subtitle_export_preset_load_title(inputs)
	if (locale === "it") return it_subtitle_export_preset_load_title(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_load_title(inputs)
	if (locale === "es") return es_subtitle_export_preset_load_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_load_title(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_load_title(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_load_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_load_title(inputs)
	return en_subtitle_export_preset_load_title(inputs)
});